import { render } from "./LabeledTextBox.vue?vue&type=template&id=72d36c82"
import script from "./LabeledTextBox.vue?vue&type=script&lang=js"
export * from "./LabeledTextBox.vue?vue&type=script&lang=js"

import "./LabeledTextBox.vue?vue&type=style&index=0&id=72d36c82&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__